import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import { Button, Switch, InputAdornment, ToggleButton, ToggleButtonGroup, IconButton, FormGroup, FormControlLabel, Checkbox, Stack, Box, Typography, Grid, FormHelperText, FormControl, InputLabel, Select, MenuItem, TextField, FormLabel } from '@mui/material';
import { authKey, GET_ADDRESS_BY_IFSC } from '../../../../common/URLs'

import jwt from 'jwt-decode';
import { BLOCK_LIST, ROLES, REVENUE_CIRCLE, TRANSPORTATION_TRADE_LICENSE, PAN_CARD, BANK_CANCELLED_CHEQUE, API_DATE_FORMAT, BASIC_DATE_FORMAT, MOA_REGISTRATION_CERTIFICATE, SALUTATION, EMPTY_FIELD_ERROR, CONSTANTS, BANK_STATEMENT, INVALID_OTP_ERROR, MOBILE_NO_ERROR, RESOURCE_ROLES } from "../../../../common/constants";
import moment from "moment";
import resolveIcon from "../../../../images/resolved.png";
import { emailValidation, nameValidation, typeNumberValid, VALIDATION, maxNameLength, openTextFieldMaxLength } from "../../../../common/commonValidations";
import { getLocalStorageItem } from "../../../../common/localStorageUtils";
import { GENDER } from "../../../../common/constants";
import { FileUploadMUI } from "../../../../common/fileUpload/fileUploadMUI";
import { CommonPincodeMUI } from "../../../../common/common-pincode/commonPincodeMUI";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { sendOTP, validateOTP } from '../../../../common/Utils';
import { useTranslation } from "react-i18next";
import { useTransporterContextData } from "./registrationDetailsTransporter";
import { CheckCircle as TickIcon, Search as SearchIcon, Cancel as CrossIcon, ArrowForwardIosSharp as AccordionIcon } from '@mui/icons-material';
import { insertComment } from '../commonRegistrationStakeholderAPIs';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { DataGrid } from '@mui/x-data-grid';
import { toast } from 'react-toastify';
import Badge from 'react-bootstrap/Badge';
import { handleNumberFieldFocus } from "../../../../common/commonFunction";
import { SaveIcon } from "../../../../common/icons";
import BadgeComponent from '../../../../common/badge';
import { addressMaxLength, emailUrnPassMaxLength, mobileNoMaxLength, approverCommentMaxLength, govtIDcardLength, totalClumpsMaxLength, mobileNumberValidation, otpMaxLength, pincodeValidation, plotValidationForKatha, plotValidationForOtherUnits, totalNumberOfClumpValidation, totalPlotsMaxLength } from '../../../../common/commonValidations';
import apiClient from "../../../../axios";
import CommentIcon from '@mui/icons-material/Comment';



const PersonalDetailsTransporter = () => {
  const { viewOnly, transporterDetails, tradeLicenseEndDate, setTradeLicenseEndDate, setTradeLicenseEndDateDisplay, tradeLicenseEndDateDisplay, fullName, setFullName, documentArray, setDocumentArray, mobileNumber, setMobileNumber, mobileNumberError, setMobileNumberError, emailId, setEmailId, panNumber, setPanNumber, tradeLicenseNo, setTradeLicenseNo, setAccountNumber, accountNumber, accountHolderName, setAccountHolderName, setBankName, ifscCode, setIfscCode, contactPersonDetails, setContactPersonDetails, certificateType, details, setCertificateType, otherIdType, setOtherIdType, addressDetails, setAddressDetails, certificateNumber, setCertificateNumber, otpValue, setOtpValue, verifyMobileNo, setVerifyMobileNo, otpHidden, setOtpHidden, mobileOTPValidated, setMobileOTPValidated, bankDetails, setBankDetails, branchName, setBranchName, applicantType, setApplicantType,
    isMSMERadio,
    setIsMSMERadio,
    msmeCategory,
    setMsmeCategory,
    personalDetailsSectionOk, setPersonalDetailsSectionOk, bankDetailsSectionOk, setBankDetailsSectionOk, shouldActOnSection, showCommentSection, setCommentsData, comments, enableFieldFunction, errorMessage, setErrorMessage, expandedSection, setExpandedSection, regScruResourceUpdate, setRegScruResourceUpdate } = useTransporterContextData();
  const { t } = useTranslation();
  const uuid = localStorage.getItem('uuid');
  const decoded = jwt(getLocalStorageItem('id_token'));
  let userRole = localStorage.getItem('role');
  const [characterLimit] = useState(300);
  let personalComments = comments?.filter((item) => item.sectionName === "personal_details");
  let bankComments = comments?.filter((item) => item.sectionName === "bank_details");
  const [personalComment, setPersonalComment] = useState("");
  const [bankComment, setBankComment] = useState("");
  const MSME_CATEGORY_OPTIONS = [
    { key: "MSM1", description: "Micro:Goods Mnfg/Spl" },
    { key: "MSM2", description: "Micro:Service Provdr" },
    { key: "MSM3", description: "Small:Goods Mnfg/Spl" },
    { key: "MSM4", description: "Small:Service Provdr" },
    { key: "MSM5", description: "Medium:Good Mnfg/Spl" },
    { key: "MSM6", description: "Medium:Service Provdr" },
    { key: "MSM7", description: "Other:Goods Mnfg/Spl" },
    { key: "MSM8", description: "Other:Service Provdr" },
    { key: "OTHER", description: "Others" }
  ];

  useEffect(() => {
    if (applicantType === "Individual") {
      setIsMSMERadio("NO");
      setMsmeCategory("");
    }
  }, [applicantType]);

  const commentsColumn = [
    {
      field: 'comment', headerName: t('reg.comments'), width: 330,
      renderCell: (params) => {
        return (
          <div style={{ wordBreak: "break-all", overflowWrap: "break-word", whiteSpace: "normal", minHeight: "auto" }}>
            {params.value.split('<br />').map((line, index) => (
              <>
                {line}
                <br />
              </>
            ))}
          </div>
        )
      }
    },
    {
      field: 'createdByName', headerName: t('preReg.name'), width: 200
    },
    {
      field: 'userRole', headerName: t('reg.userRole'), width: 200
    },
    {
      field: 'createdOnFormatted', headerName: t('reg.date'), width: 200,
    },
  ]

  const onTradeLicenseEndDateChange = (e) => {
    setTradeLicenseEndDateDisplay(e.format(BASIC_DATE_FORMAT))
    setTradeLicenseEndDate(e.format(API_DATE_FORMAT))
  }

  const onFullNameChange = (e) => {
    e.preventDefault();
    setFullName(e.target.value.slice(0, 100))

  }
  const onMobileChange = (e) => {
    e.preventDefault();
    setMobileNumber(e.target.value);
    if ((e.target.value).length != 10) {
      setMobileNumberError('Please enter 10 digit Mobile number')
    } else {
      setMobileNumberError('')
    }

  }
  const onEmailChange = (e) => {
    e.preventDefault();
    setEmailId(e.target.value.slice(0, 100));
    if ((e.target.value).length > 0) {
      if (emailValidation(e.target.value)) {
        setErrorMessage({ ...errorMessage, emailIdError: "" })
      } else setErrorMessage({ ...errorMessage, emailIdError: "Please enter valid email" })
    }
  }

  const onPanNumberChange = (e) => {
    const limit = 10;
    const cleaned = e.target.value
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, '');      // remove invalid chars
    const sliced = cleaned.slice(0, limit); // enforce limit 10
    setPanNumber(sliced);
    if (sliced.length === 10 && VALIDATION.panNumberValidation(sliced)) {
      setErrorMessage({ ...errorMessage, panNumberError: "" });
    } else {
      setErrorMessage({ ...errorMessage, panNumberError: "Please enter valid PAN Number" });
    }
  };

  const onTradeLicenseNoChange = (e) => {
    e.preventDefault();
    setTradeLicenseNo(VALIDATION.noSpecialCharCapsValidation(e.target.value.toUpperCase().slice(0, 50)))
  }

  const onAccountNumberChange = (e) => {
    e.preventDefault();
    const limit = 18;
    setAccountNumber(e.target.value.slice(0, limit))
    if (e.target.value.length > 0 && VALIDATION.bankAccountNumberValidation(e.target.value.slice(0, limit))) {
      setErrorMessage({ ...errorMessage, accountNumberError: "" })
      setAccountNumber(e.target.value.slice(0, limit))
    } else setErrorMessage({ ...errorMessage, accountNumberError: 'Please enter valid Account Number' })
  }

  const onAccountHolderNameChange = (e) => {
    e.preventDefault();
    setAccountHolderName(VALIDATION.fullNameValidation(e.target.value))

    if (e.target.value.length > 0 && VALIDATION.fullNameValidation(e.target.value)) {
      setAccountHolderName(VALIDATION.fullNameValidation(e.target.value))
      setErrorMessage({ ...errorMessage, accountHolderNameError: "" })
    }
    else {
      setErrorMessage({ ...errorMessage, accountHolderNameError: "Please enter Account Holder's Name" })
    }
  }

  const onBranchChangeName = (e) => {
    e.preventDefault();
    if (branchName.length === 0) {
      setBranchName(e.target.value)
    } else {
      setBranchName("")

    }
  }
  const onIfscCodeChange = (e) => {
    e.preventDefault();
    setIfscCode(e.target.value.toUpperCase().replace(/[^a-zA-Z0-9]/gi, '').slice(0, 11));
    if (e.target.value.length > 0 && VALIDATION.ifscValidation(e.target.value)) {
      setErrorMessage({ ...errorMessage, ifscCodeError: "" })
      setIfscCode(e.target.value.toUpperCase().replace(/[^a-zA-Z0-9]/gi, '').slice(0, 11));
      setBranchName("");
    } else setErrorMessage({ ...errorMessage, ifscCodeError: "Please enter valid IFSC Code" })
  }
  const onContactPersonDetailChange = (e) => {
    e.preventDefault();
    setContactPersonDetails({ ...contactPersonDetails, [e.target.name]: e.target.value });
    if (e.target.name === "contactPersonFirstName") {
      setContactPersonDetails({ ...contactPersonDetails, [e.target.name]: nameValidation(e.target.value.slice(0, 50)) })
      if ((e.target.value).length > 0) {
        setContactPersonDetails({ ...contactPersonDetails, [e.target.name]: nameValidation(e.target.value.slice(0, 50)) })
        setErrorMessage({ ...errorMessage, contactPersonFirstNameError: '' })
      } else return
    }
    if (e.target.name === "contactPersonMiddleName") {
      setContactPersonDetails({ ...contactPersonDetails, [e.target.name]: nameValidation(e.target.value.slice(0, 50)) })
      if ((e.target.value).length > 0) {
        setContactPersonDetails({ ...contactPersonDetails, [e.target.name]: nameValidation(e.target.value.slice(0, 50)) })
      } else return
    }
    if (e.target.name === "contactPersonLastName") {
      setContactPersonDetails({ ...contactPersonDetails, [e.target.name]: nameValidation(e.target.value.slice(0, 50)) })
      if ((e.target.value).length > 0) {
        setContactPersonDetails({ ...contactPersonDetails, [e.target.name]: nameValidation(e.target.value.slice(0, 50)) })
      } else return
    }
  }

  const onCertificateTypeChange = (e) => {
    e.preventDefault();
    if (e.target.name === "certificateType") {
      setCertificateType(e.target.value);
    }
    else if (e.target.name === 'otherGovtCardType') {
      const limit = 50;
      if (e.target.value.length > 0) {
        setOtherIdType({ ...otherIdType, [e.target.name]: VALIDATION.fullNameValidation(e.target.value).slice(0, limit) });
        setErrorMessage({ ...errorMessage, otherCardError: '' })
      }
      else {
        setErrorMessage({ ...errorMessage, otherCardError: 'Please enter ID Proof Name' })
      }
    }

  }
  const onAddressChange = (e) => {
    e.preventDefault();
    setAddressDetails({
      ...addressDetails,
      address: VALIDATION.noSpecialCharacterValidation(e.target.value.slice(0, 200))
    })
  }
  const onApplicantChange = (e) => {
    e.preventDefault();
    setApplicantType(e.target.value);
  }
  const onGenderChange = (e) => {
    e.preventDefault();
    setContactPersonDetails({ ...contactPersonDetails, [e.target.name]: e.target.value })
  }

  const getUpdatedAddressData = (data) => {
    setAddressDetails({
      ...addressDetails,
      pincode: data.pincode,
      state: data.pincodeState,
      district: data.pincodeDistrict,
      subDivision: data.pincodeSubDivision,
      revenueCircle: data.selectedRevenueCircle,
      blockName: data.selectedBlockName,

    })
  }
  const handleChangeSelect = (e, type) => {
    if (type == BLOCK_LIST) {
      setAddressDetails({
        ...addressDetails,
        blockName: e.target.value,

      })
    }
    if (type == REVENUE_CIRCLE) {
      setAddressDetails({
        ...addressDetails,
        revenueCircle: e.target.value,

      })
    }
  }

  const onClickCertificateNumber = (e) => {
    e.preventDefault();
    setCertificateNumber(VALIDATION.noSpecialCharCapsValidation(e.target.value.toUpperCase().slice(0, 50)));

  }
  const onUploadCallBack = (docArray) => {
    setDocumentArray(docArray);
  }

  const onClickVerifyMobileNo = (e) => {
    e.preventDefault();
    setErrorMessage({ ...errorMessage, OTPError: "" });
    setOtpValue("");
    if (isValidMobileNumber(mobileNumber)) {
      sendOTP(mobileNumber, callBackMobileValidation);
      setErrorMessage({ ...errorMessage, mobileNumberError: "" });
    }
    else
      setErrorMessage({ ...errorMessage, mobileNumberError: MOBILE_NO_ERROR });
  }
  const callBackMobileValidation = (response) => {
    setErrorMessage({ ...errorMessage, mobileNumberError: "" });
    if (response.isSuccess) {
      setErrorMessage({ ...errorMessage, OTPSentError: "" })
      setErrorMessage({ ...errorMessage, mobileNumberError: "" });
      setVerifyMobileNo(true);
      setOtpHidden(false);
      setErrorMessage({ ...errorMessage, OTPError: "" });
    }

  }
  const onOtpChange = (e) => {
    const limit = 6;
    setOtpValue(e.target.value.slice(0, limit))
    if (e.target.value.length == 6) {
      validateOTP(mobileNumber, e.target.value, callBackOTPValidation);
    }
  }
  const callBackOTPValidation = (response) => {
    setErrorMessage({ ...errorMessage, OTPSentError: "" });
    setErrorMessage({ ...errorMessage, mobileNumberError: "" });
    if (response.isSuccess === true) {
      setVerifyMobileNo(false);
      setOtpHidden(true);
      setMobileOTPValidated(true);
      setErrorMessage({ ...errorMessage, OTPError: "" });
      setErrorMessage({ ...errorMessage, mobileNumberError: "" });
    }
    else {
      setErrorMessage({ ...errorMessage, mobileNumberError: INVALID_OTP_ERROR });
    }
  }
  const isValidMobileNumber = (mobileNumber) => {
    if (mobileNumber.length == 10) {
      return true;
    }
    return false;
  }

  const getBankDetails = () => {
    apiClient
      .post(GET_ADDRESS_BY_IFSC,
        {
          "ifsc": ifscCode,
        },
        {
          headers: {
            AuthKey: authKey,
          },
        }
      )
      .then((response) => {
        if (response.data.isSuccess === true) {
          setBankDetails(response.data);
        }
        else {
          setIfscCode("");
          setBranchName("");
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const onSaveComment = (comment, sectionName, sectionOk) => {
    const commentObject = {
      comment: comment,
      stakeholderMasterId: transporterDetails?.transporterMasters[0]?.regStakeholderMasterId,
      sectionName: sectionName,
      sectionId: transporterDetails?.transporterMasters[0]?.id,
      sectionOk: sectionOk,
      userRole: localStorage.getItem('role'),
      createdBy: decoded.extension_URN ? transporterDetails?.transporterMasters[0]?.regStakeholderMasterId : uuid,
    }
    comment ? insertComment([commentObject], transporterDetails?.transporterMasters[0]?.regStakeholderMasterId, setCommentsData) : toast.error("Please enter comment")
    setPersonalComment("");
    setBankComment("");
    setErrorMessage({ ...errorMessage, personalCommentError: "", bankCommentError: "" });
  }

  return (
    <>
      {transporterDetails && <>
        <Grid item xs={12}>
          <Accordion mt={1} expanded={expandedSection === "personal"}
            onChange={(event, expanded) => {
              setExpandedSection(expanded ? "personal" : "");
            }}>
            <AccordionSummary sx={{ flexDirection: 'row-reverse', backgroundColor: showCommentSection && !regScruResourceUpdate ? (personalDetailsSectionOk ? "#E9FBF0" : "#FFEBEE") : "FFFFFF" }}
              expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
            >
              <Stack ml={2} display="flex" alignItems="center" direction="row">
                {showCommentSection && !regScruResourceUpdate && (personalDetailsSectionOk ? <TickIcon sx={{ fontSize: 20, color: "#64dd17", marginRight: "1vh" }} /> : <CrossIcon sx={{ fontSize: 20, color: "#f44336", marginRight: "1vh" }} />)}
                <Typography variant="subtitle1">{applicantType === "Individual" ? t('preReg.personalDetails') : t('preReg.organizationDetails')}</Typography>
              </Stack>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container pr={4} pb={3} spacing={2} sx={{ backgroundColor: showCommentSection && !regScruResourceUpdate ? (personalDetailsSectionOk ? "#E9FBF0" : "#FFEBEE") : "FFFFFF", width: "103.5%" }}>
                <Grid item xs={12} lg={6}>
                  <Typography variant="subtitle2" gutterBottom>
                    {t('preReg.applicantType')}
                  </Typography>
                  <ToggleButtonGroup style={{ display: "flex", overflow: "auto" }}
                    color="primary"
                    value={applicantType || ''}
                    exclusive
                    onChange={(e) => onApplicantChange(e)}
                    disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                    aria-label="Platform"
                  >
                    <ToggleButton value="Individual">{t('preReg.individual')}</ToggleButton>
                    <ToggleButton value="Partnership">{t('preReg.partnership')}</ToggleButton>
                    <ToggleButton value="Proprietorship">{t('preReg.proprietorship')}</ToggleButton>
                    <ToggleButton value="Company">{t('preReg.company')}</ToggleButton>
                  </ToggleButtonGroup>
                </Grid>
                {/* <Grid item xs={12} lg={4}>
                  <TextField fullWidth
                    disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                    required
                    error={errorMessage.applicantTypeError}
                    helperText={errorMessage.applicantTypeError}
                    type="text" label={t('preReg.applicantType')}
                    name="applicantType"
                    value={applicantType || ''}
                    inputProps={{
                      maxLength: maxNameLength
                    }}
                    onChange={(e) => onApplicantChange(e)}
                  />
                </Grid> */}
                <Grid item xs={12} lg={6} mt={2}>
                  <TextField fullWidth
                    required
                    error={errorMessage.fullNameError}
                    helperText={errorMessage.fullNameError}
                    disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                    type="text" label={t('reg.fullName')}
                    name="name"
                    value={fullName || ''}
                    multiline
                    onChange={(e) => onFullNameChange(e)} inputProps={{
                      maxLength: maxNameLength
                    }} />
                  <BadgeComponent currentLength={fullName?.length} maxLength={maxNameLength} />
                </Grid>
                {applicantType !== "Individual" && (
                  <Grid item xs={12} lg={2}>
                    <FormControl>
                      <FormLabel sx={{ fontWeight: 600 }}>
                        Is MSME?
                      </FormLabel>

                      <ToggleButtonGroup
                        exclusive
                        value={isMSMERadio}
                        onChange={(e, value) => value && setIsMSMERadio(value)}
                        disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                        sx={{ mt: 1 }}
                      >
                        <ToggleButton value="YES">Yes</ToggleButton>
                        <ToggleButton value="NO">No</ToggleButton>
                      </ToggleButtonGroup>
                    </FormControl>
                  </Grid>
                )}
                {applicantType !== "Individual" && isMSMERadio === "YES" && (
                  <Grid item xs={12} lg={4} mt={3}>
                    <FormControl fullWidth>
                      <InputLabel>MSME Category</InputLabel>
                      <Select
                        label="MSME Category"
                        value={msmeCategory}
                        onChange={(e) => setMsmeCategory(e.target.value)}
                        disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                      >
                        {MSME_CATEGORY_OPTIONS.map(option => (
                          <MenuItem key={option.key} value={option.key}>
                            <strong>{option.key}</strong> — {option.description}
                          </MenuItem>

                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                )}
                {applicantType !== "Individual" && isMSMERadio === "YES" && (
                  <Grid item xs={12} lg={6} mt={2}>
                    <FileUploadMUI
                      key="MSME_Certificate"
                      documentList={documentArray}
                      documentType="MSME_Certificate"
                      callBackDocumentUpload={onUploadCallBack}
                      stakeholderDetailId={transporterDetails?.transporterMasters[0]?.regStakeholderMasterId}
                      title="Upload MSME Certificate"
                      stakeholderType="Transporter"
                      disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                      errorMessage={errorMessage}
                      setErrorMessage={setErrorMessage}
                      documentError="msmeDocError"
                    />
                  </Grid>
                )}
                <Grid item xs={12}>
                  <Typography variant="h6" gutterBottom>
                    {t('preReg.contactPersonDetails')}
                  </Typography>
                </Grid>
                <Grid item xs={4} lg={2}>
                  <FormControl fullWidth>
                    <InputLabel>{t('preReg.salutation')}</InputLabel>
                    <Select
                      label={t('preReg.salutation')}
                      disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                      value={contactPersonDetails.contactPersonSalutation}
                      name="contactPersonSalutation"
                      onChange={(e) => onContactPersonDetailChange(e)}>
                      {SALUTATION.map((item) => <MenuItem key={item} value={item}>{item}</MenuItem>)}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={8} lg={4}>
                  <TextField fullWidth
                    required
                    error={errorMessage.contactPersonFirstNameError}
                    helperText={errorMessage.contactPersonFirstNameError}
                    disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                    type="text"
                    label={t('preReg.firstname')}
                    value={contactPersonDetails.contactPersonFirstName}
                    name="contactPersonFirstName"
                    onChange={(e) => onContactPersonDetailChange(e)}
                    inputProps={{
                      maxLength: maxNameLength
                    }}
                  />
                  <BadgeComponent currentLength={contactPersonDetails?.contactPersonFirstName?.length} maxLength={maxNameLength} />
                </Grid>
                <Grid item xs={6} lg={3}>
                  <TextField fullWidth
                    disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                    type="text"
                    value={contactPersonDetails.contactPersonMiddleName}
                    name="contactPersonMiddleName"
                    label={t('preReg.middlename')}
                    onChange={(e) => onContactPersonDetailChange(e)}
                    inputProps={{
                      maxLength: maxNameLength
                    }}
                  />
                  <BadgeComponent currentLength={contactPersonDetails?.contactPersonMiddleName?.length} maxLength={maxNameLength} />
                </Grid>
                <Grid item xs={6} lg={3}>
                  <TextField fullWidth
                    disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                    type="text"
                    label={t('preReg.lastname')}
                    value={contactPersonDetails.contactPersonLastName}
                    name="contactPersonLastName"
                    onChange={(e) => onContactPersonDetailChange(e)}
                    inputProps={{
                      maxLength: maxNameLength
                    }}
                  />
                  <BadgeComponent currentLength={contactPersonDetails?.contactPersonLastName?.length} maxLength={maxNameLength} />
                </Grid>
                <Grid item xs={4} lg={2}>
                  <FormControl fullWidth error={errorMessage?.genderError}>
                    <InputLabel>{t('preReg.gender')}</InputLabel>
                    <Select
                      required
                      label={t('preReg.gender')}
                      name='contactPersonGender'
                      disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                      value={contactPersonDetails.contactPersonGender}
                      onChange={(e) => onGenderChange(e)}
                    >

                      {GENDER.map((item) => <MenuItem value={item}>{item}</MenuItem>)}
                    </Select>
                    {/* <FormHelperText sx={{ color: 'red' }}>{errorMessage?.genderError}</FormHelperText> */}
                  </FormControl>
                </Grid>
                <Grid item xs={8} lg={4}>
                  <TextField fullWidth required error={mobileNumberError} helperText={mobileNumberError} onFocus={handleNumberFieldFocus} label={t('preReg.mobileNo')} name="mobileNo" disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)} value={mobileNumber} onChange={(e) => onMobileChange(e)} />
                  {verifyMobileNo === true ?
                    <div>
                      <a href='#' className="commonVerifyText" onClick={(e) => onClickVerifyMobileNo(e)}>Resend OTP</a></div>
                    : transporterDetails?.transporterMasters[0]?.regStakeholderMaster?.isOtpValidated ?
                      <div className="commonVerifyText"><a href="#" style={{ marginLeft: "1vw" }}>Verified</a>
                        <img className="commonOtpImg" src={resolveIcon} alt="" /></div> : mobileOTPValidated === true ? <div hidden={!mobileOTPValidated}><a className="otp-linklle" href="#">Verified</a>
                          <img className="commonOtpImg" src={resolveIcon} alt="" /></div> :
                        <button className="commonVerifyText" onClick={(e) => onClickVerifyMobileNo(e)}>Verify Mobile no.</button>
                  }
                </Grid>
                {verifyMobileNo &&
                  <Grid item xs={3} lg={2}>
                    <TextField fullWidth type="number" onChange={(e) => onOtpChange(e)} value={otpValue} label={t('preReg.otp')} onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '.' || evt.key === '-' || evt.key === '+') && evt.preventDefault()} />
                    <BadgeComponent currentLength={otpValue?.mobileNo?.length} maxLength={mobileNoMaxLength} />
                  </Grid>}
                <Grid item xs={12} lg={6}>
                  <TextField fullWidth
                    required
                    error={errorMessage.emailIdError}
                    helperText={errorMessage.emailIdError}
                    type="text"
                    disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                    label={t('main.email')}
                    name="emailId"
                    value={emailId}
                    onChange={(e) => onEmailChange(e)} />
                  <BadgeComponent currentLength={emailId?.emailId?.length} maxLength={emailUrnPassMaxLength} />
                </Grid>
                <Grid item xs={12} lg={4}>
                  <TextField fullWidth
                    required
                    error={errorMessage.panNumberError}
                    helperText={errorMessage.panNumberError}
                    type="text"
                    disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                    label={t('reg.panNumber')}
                    name="panNumber"
                    value={panNumber}
                    onChange={(e) => onPanNumberChange(e)}
                    InputProps={{
                      maxLength: 10,
                      style: { textTransform: "uppercase" }
                    }}

                  />
                  <BadgeComponent currentLength={panNumber?.length} maxLength={10} />
                  <FileUploadMUI key={PAN_CARD}
                    documentList={documentArray}
                    documentType={PAN_CARD}
                    callBackDocumentUpload={onUploadCallBack}
                    stakeholderDetailId={transporterDetails?.transporterMasters[0]?.regStakeholderMasterId}
                    title={t('preReg.uploadPanDoc')}
                    stakeholderType="Transporter"
                    disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                    errorMessage={errorMessage}
                    setErrorMessage={setErrorMessage}
                    documentError="panDocError"
                  />

                  {/* <div className='mandatory_field'>{errorMessage.panDocError}</div> */}
                </Grid>
                <Grid item xs={6} lg={certificateType === "Other" ? 2 : 4}>
                  <FormControl fullWidth>
                    <InputLabel>{t('preReg.idProof')}</InputLabel>
                    <Select

                      label={t('preReg.idProof')}
                      name="certificateType"
                      disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                      value={certificateType}
                      onChange={(e) => onCertificateTypeChange(e)} >
                      <MenuItem disabled value=""> Certificate Type</MenuItem>
                      {CONSTANTS.ID_PROOF_ARRAY.map((item) => <MenuItem value={item}>{item}</MenuItem>)}
                    </Select>
                  </FormControl>
                </Grid>
                {certificateType === "Other" &&
                  <Grid item xs={6} lg={3}>
                    <TextField fullWidth
                      disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                      type="text"
                      label={t('preReg.enterIdProof')} name="otherGovtCardType"
                      defaultValue={otherIdType}
                      onChange={(e) => onCertificateTypeChange(e)}
                      InputProps={{
                        style: { textTransform: "uppercase" }
                      }} />
                  </Grid>}
                <Grid item xs={12} lg={certificateType === "Other" ? 3 : 4}>
                  <TextField fullWidth
                    required
                    error={errorMessage.certificateNumberError}
                    helperText={errorMessage.certificateNumberError}
                    type="text"
                    disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                    label={certificateType === "MOA" ? t('preReg.enterMOA') : certificateType === "Registration Certificate" ? t('preReg.enterRegNo') : certificateType === "GST" ? t('preReg.enterGSTNo') : t('preReg.enterNo')}
                    name="certificateNumber"
                    value={certificateNumber}
                    onChange={(e) => onClickCertificateNumber(e)}
                    InputProps={{
                      maxLength: (certificateType === "Registration Certificate" || certificateType === "MOA") ? 30 : 20,
                      style: { textTransform: "uppercase" }
                    }}
                  />
                  <BadgeComponent currentLength={certificateNumber?.govtIDcardLength?.length} maxLength={govtIDcardLength} />
                  <FileUploadMUI key={MOA_REGISTRATION_CERTIFICATE}
                    documentList={documentArray}
                    documentType={MOA_REGISTRATION_CERTIFICATE}
                    callBackDocumentUpload={onUploadCallBack}
                    stakeholderDetailId={transporterDetails?.transporterMasters[0]?.regStakeholderMasterId}
                    title={t('reg.uploadRegistrationDoc')}
                    stakeholderType="Transporter"
                    disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                    errorMessage={errorMessage}
                    setErrorMessage={setErrorMessage}
                    documentError="idProofDocError"
                  />
                  {/* <div className='mandatory_field'>{errorMessage.idProofDocError}</div> */}
                </Grid>
                <Grid item xs={6} lg={3} mt={1}>
                  <TextField fullWidth
                    //required
                    error={errorMessage.tradeLicenseNoError}
                    helperText={errorMessage.tradeLicenseNoError}
                    type="text"
                    label={t('reg.tradeLicenseNo')}
                    name="hitTradeLicenseNo"
                    value={tradeLicenseNo}
                    onChange={(e) => onTradeLicenseNoChange(e)}
                    InputProps={{
                      maxLength: 20,
                      style: { textTransform: "uppercase" }
                    }}

                    disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)} />
                  <FileUploadMUI key={TRANSPORTATION_TRADE_LICENSE}
                    documentList={documentArray}
                    documentType={TRANSPORTATION_TRADE_LICENSE}
                    callBackDocumentUpload={onUploadCallBack}
                    stakeholderDetailId={transporterDetails?.transporterMasters[0]?.regStakeholderMasterId}
                    title={t('reg.uploadTradeLicenseDoc')}
                    stakeholderType="Transporter"
                    disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                    errorMessage={errorMessage}
                    setErrorMessage={setErrorMessage}
                    documentError="tradeLicenseDocError"
                  />
                  {/* <div className='mandatory_field'>{errorMessage.tradeLicenseDocError}</div> */}
                </Grid>
                <Grid item xs={6} lg={3} mt={1}>
                  <FormControl fullWidth>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DesktopDatePicker
                        //required
                        // error={errorMessage.agreementSatrtDateError}
                        // helperText={errorMessage.agreementSatrtDateError}
                        inputFormat="DD/MM/YYYY"
                        label={t('reg.validTill')}
                        value={tradeLicenseEndDateDisplay}
                        name="tradeLicenseEndDate"
                        onChange={(e) => onTradeLicenseEndDateChange(e)}
                        minDate={moment(new Date()).format(API_DATE_FORMAT)}
                        disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                        renderInput={(params) => <TextField {...params} />}
                        sx={{ paddingRight: '3%' }}
                      />
                    </LocalizationProvider>
                  </FormControl>
                </Grid>
                <Grid item xs={12} lg={6} mt={1}>
                  <TextField fullWidth
                    required
                    error={errorMessage.addressError}
                    helperText={errorMessage.addressError}
                    disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                    type="text"
                    label={t('main.address')}
                    name="address"
                    multiline
                    value={addressDetails.address}
                    onChange={(e) => onAddressChange(e)}
                    inputProps={{
                      maxLength: addressMaxLength,
                      style: { textTransform: "capitalize" }
                    }} />
                  <BadgeComponent currentLength={addressDetails?.address?.length} maxLength={addressMaxLength} />
                </Grid>
                <CommonPincodeMUI setErrorMessage={setErrorMessage}
                  fullWidth={true}
                  revenueNotRequired={true}
                  isDisabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                  pincode={addressDetails.pincode}
                  state={addressDetails.state}
                  district={addressDetails.district}
                  revenueCircle={addressDetails.revenueCircle}
                  blockName={addressDetails.blockName}
                  onHandleCallback={getUpdatedAddressData}
                  pincodeError={errorMessage.pincodeError}
                  searchError={errorMessage.searchError}
                  handleChangeSelect={handleChangeSelect}
                /></Grid>
              {showCommentSection && <><Grid container direction="row" mt={2} mb={2} alignItems="center" spacing={2}>
                <Grid item xs={8}>
                  <TextField sx={{ width: "100%" }}
                    label={t('reg.comment')}
                    helperText={errorMessage.personalCommentError}
                    error={errorMessage.personalCommentError}
                    name="comment"
                    inputProps={{
                      maxLength: 300
                    }}
                    multiline
                    disabled={!shouldActOnSection.personal_details || viewOnly}
                    value={personalComment}
                    onChange={(e) => setPersonalComment(VALIDATION.noSpecialCharacterValidation(e.target.value))}
                  />
                  <BadgeComponent currentLength={personalComment?.plotComment?.length} maxLength={approverCommentMaxLength} />
                  {/* <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '1vh' }}>
                    <Badge bg={`${personalComment?.length > characterLimit ? 'danger' : 'primary'}`}>{personalComment?.length}/{characterLimit}</Badge>
                  </div> */}
                </Grid>
                <Grid item xs={2}>
                  <FormGroup>
                    <FormControlLabel control={<Switch disabled={!shouldActOnSection.personal_details || viewOnly} checked={personalDetailsSectionOk}
                      onChange={(e) => setPersonalDetailsSectionOk(e.target.checked)} />} label={<Typography variant="subtitle2">
                        {t('reg.detailsOk')}?
                      </Typography>} />
                  </FormGroup>
                </Grid>
                <Grid xs={2}>
                  <Button variant="contained" disabled={!shouldActOnSection.personal_details || viewOnly}
                    onClick={() => onSaveComment(personalComment, "personal_details", personalDetailsSectionOk)}
                    startIcon={<CommentIcon />}
                  >
                    {t('preReg.addComment')}
                  </Button>
                </Grid>
              </Grid>
                <div>
                  <Accordion mt={1} >
                    <AccordionSummary
                      expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
                    >
                      <Typography variant="subtitle1" ml={2}>{t('reg.commentHistory')}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Box style={{ height: 300, width: '100%' }}>
                        <DataGrid
                          rows={personalComments ? personalComments : []}
                          columns={commentsColumn}
                          pageSize={10}
                          getRowHeight={() => 'auto'} />
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                </div></>}
            </AccordionDetails>

          </Accordion>
        </Grid>
        <Grid item xs={12}>
          <Accordion mt={1} expanded={expandedSection === "bank"}
            onChange={(event, expanded) => {
              setExpandedSection(expanded ? "bank" : "");
            }}>
            <AccordionSummary sx={{ flexDirection: 'row-reverse', backgroundColor: showCommentSection && !regScruResourceUpdate ? (bankDetailsSectionOk ? "#E9FBF0" : "#FFEBEE") : "FFFFFF" }}
              expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
            >
              <Stack ml={2} display="flex" alignItems="center" direction="row">
                {showCommentSection && !regScruResourceUpdate && (bankDetailsSectionOk ? <TickIcon sx={{ fontSize: 20, color: "#64dd17", marginRight: "1vh" }} /> : <CrossIcon sx={{ fontSize: 20, color: "#f44336", marginRight: "1vh" }} />)}
                <Typography variant="subtitle1">{t('preReg.bankDetails')}</Typography>
              </Stack>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container pr={4} pb={3} spacing={2} sx={{ backgroundColor: showCommentSection && !regScruResourceUpdate ? (bankDetailsSectionOk ? "#E9FBF0" : "#FFEBEE") : "FFFFFF", width: "103.5%" }}>
                <Grid item xs={12} lg={6}>
                  <TextField fullWidth
                    required
                    error={errorMessage.accountNumberError}
                    helperText={errorMessage.accountNumberError}
                    disabled={!enableFieldFunction(shouldActOnSection.bank_details, false)}
                    type="number"
                    onFocus={handleNumberFieldFocus}
                    label={t('preReg.accountNo')}
                    name="bankAccountNumber"
                    value={accountNumber}
                    onChange={(e) => onAccountNumberChange(e)}
                    inputProps={{
                      maxLength: 20
                    }}
                    onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '.' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
                  />
                </Grid>
                <Grid item xs={12} lg={6}>
                  <TextField fullWidth required error={errorMessage.accountHolderNameError} helperText={errorMessage.accountHolderNameError} disabled={!enableFieldFunction(shouldActOnSection.bank_details, false)} type="text" label={t('preReg.accountHolderName')} name="bankAccountHolderName" value={accountHolderName} onChange={(e) => onAccountHolderNameChange(e)} inputProps={{
                    maxLength: maxNameLength
                  }} />
                </Grid>
                <Grid item xs={12} lg={6}>
                  <TextField fullWidth
                    required
                    error={errorMessage.ifscCodeError}
                    helperText={errorMessage.ifscCodeError}
                    type="text"
                    ddisabled={!enableFieldFunction(shouldActOnSection.bank_details, false)}
                    name="bankIfscCode"
                    label={t('preReg.ifscCode')}
                    value={ifscCode}
                    onChange={(e) => onIfscCodeChange(e)}
                    onKeyDown={(evt) => (evt.key === '.' || evt.key === '-') && evt.preventDefault()}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton color='primary' disabled={!enableFieldFunction(shouldActOnSection.bank_details, false)} aria-label="delete" onClick={() => getBankDetails()}>
                            <SearchIcon />
                          </IconButton>
                        </InputAdornment>
                      ),
                      maxLength: 11,
                      style: { textTransform: "uppercase" }
                    }}
                  ></TextField>
                </Grid>
                <Grid item xs={12} lg={6}>
                  <TextField fullWidth type="text" label={t('preReg.branch')} name="bankAccountHolbankBranchderName" value={branchName} onChange={(e) => onBranchChangeName(e)} disabled />

                </Grid>
                <Grid item xs={12} lg={6}>
                  <FileUploadMUI key={BANK_CANCELLED_CHEQUE}
                    documentList={documentArray}
                    documentType={BANK_CANCELLED_CHEQUE}
                    callBackDocumentUpload={onUploadCallBack}
                    stakeholderDetailId={transporterDetails?.transporterMasters[0]?.regStakeholderMasterId}
                    title={t('preReg.uploadPassbookCancelledCheck')}
                    stakeholderType="Transporter"
                    disabled={!enableFieldFunction(shouldActOnSection.bank_details, false)}
                    errorMessage={errorMessage}
                    setErrorMessage={setErrorMessage}
                    documentError="bankDocError"
                  />
                  {/* <div className='mandatory_field'>{errorMessage.bankDocError}</div> */}
                </Grid>
                <Grid item xs={12} lg={6}>
                  <FileUploadMUI key={BANK_STATEMENT}
                    documentList={documentArray}
                    documentType={BANK_STATEMENT}
                    callBackDocumentUpload={onUploadCallBack}
                    stakeholderDetailId={transporterDetails?.transporterMasters[0]?.regStakeholderMasterId}
                    title={t('reg.uploadLast6monthsBankStatement')}
                    stakeholderType="Transporter"
                    disabled={!enableFieldFunction(shouldActOnSection.bank_details, false)}
                    errorMessage={errorMessage}
                    setErrorMessage={setErrorMessage}
                    documentError="bankStatementError"
                  />
                  {/* <div className='mandatory_field'>{errorMessage.bankStatementError}</div> */}
                </Grid>
              </Grid>
              {showCommentSection && <><Grid container direction="row" mt={2} mb={2} alignItems="center" spacing={2}>
                <Grid item xs={7}>
                  <TextField sx={{ width: "100%" }}
                    label={t('reg.comment')}
                    helperText={errorMessage.bankCommentError}
                    error={errorMessage.bankCommentError}
                    name="comment"
                    inputProps={{
                      maxLength: 300,
                    }}
                    multiline
                    disabled={!shouldActOnSection.bank_details || viewOnly}
                    value={bankComment}
                    onChange={(e) => setBankComment(VALIDATION.noSpecialCharacterValidation(e.target.value))}
                  />
                  <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '1vh' }}>
                    <Badge bg={`${bankComment?.length > characterLimit ? 'danger' : 'primary'}`}>{bankComment?.length}/{characterLimit}</Badge>
                  </div>
                </Grid><Grid item xs={2}>
                  <FormGroup>
                    <FormControlLabel control={<Switch disabled={!shouldActOnSection.bank_details || viewOnly} checked={bankDetailsSectionOk}
                      onChange={(e) => setBankDetailsSectionOk(e.target.checked)} />} label={<Typography variant="subtitle2">
                        {t('reg.detailsOk')}?
                      </Typography>} />
                  </FormGroup>
                </Grid><Grid item xs={3}>
                  <Button variant="contained" disabled={!shouldActOnSection.bank_details || viewOnly}
                    onClick={() => onSaveComment(bankComment, "bank_details", bankDetailsSectionOk)}
                    startIcon={<CommentIcon />}
                  >
                    {t('preReg.addComment')}
                  </Button>
                </Grid>
              </Grid>
                <div>
                  <Accordion mt={1} >
                    <AccordionSummary
                      expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
                    >
                      <Typography variant="subtitle1" ml={2}>{t('reg.commentHistory')}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Box style={{ height: 300, width: '100%' }}>
                        <DataGrid
                          rows={bankComments ? bankComments : []}
                          columns={commentsColumn}
                          pageSize={10}
                          getRowHeight={() => 'auto'} />
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                </div></>}
            </AccordionDetails>

          </Accordion>
        </Grid>
      </>}
    </>
  )

}
export default PersonalDetailsTransporter;

